import { createFileRoute } from "@tanstack/react-router"
import { ImageUpscalerScreenWrapper } from "./-ImageUpscalerPage"

export const Route = createFileRoute("/tools/image-upscaler")({
  component: ImageUpscalerScreenWrapper,
})
